import { render, staticRenderFns } from "./Caregiver.vue?vue&type=template&id=2c168e7c&"
import script from "./Caregiver.vue?vue&type=script&lang=ts&"
export * from "./Caregiver.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports